var map = {
	"./comparison-brand-brand.png": "79a1",
	"./comparison-brand-category.png": "e44b",
	"./comparison-category-category.png": "4e89",
	"./comparison-product-brand.png": "e977",
	"./comparison-product-category.png": "6395",
	"./comparison-product-product.png": "3d60",
	"./multi-product.png": "aa69",
	"./single-brand.png": "f6f2",
	"./single-category.png": "d0ff",
	"./single-product.png": "b424",
	"./single-tag.png": "2cdd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1450";